;'use strict';

const horizontalSwipeNav = function() {
    const arrowGestion = function(containerNav, scroolToEnd) {
        function updateScrollIndicators() {
            const canScrollLeft = containerNav.scrollLeft > 5;
            const canScrollRight = containerNav.scrollLeft < (containerNav.scrollWidth - containerNav.clientWidth - 1);

            containerNav.classList.toggle('can-scroll-left', canScrollLeft);
            containerNav.classList.toggle('can-scroll-right', canScrollRight);
        }

        //todo: a remplacer par le le debouce global
        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        if (containerNav) {
            const debouncedUpdate = debounce(updateScrollIndicators, 150);

            containerNav.addEventListener('scroll', debouncedUpdate);
            window.addEventListener('resize', debouncedUpdate);

            if(scroolToEnd) {

                setTimeout(() => {
                    containerNav.scrollLeft = containerNav.scrollWidth;
                    updateScrollIndicators();
                }, 100);
            }

        }
    }
    return {
        arrowGestion: arrowGestion
    }
}();